import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message, Spin } from 'antd'
import MyInput from '../../components/forms/input'
import MyImageUpload from '../../components/forms/imageUpload'
import MyVideoUpload from '../../components/forms/videoUpload'
import MySeriesSelect from '../../components/select/seriesSelect'

const EditFitnessVideo = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    axios.post('/admin/content/fitness_video/detail/get', {
      video_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '视频名称不能为空'})
      return false
    }
    if (!formValue.series_oid) {
      setErrorMsg({seriesEmpty: '请选择视频所属健身系列'})
      return false
    }
    if (!formValue.video_url) {
      setErrorMsg({videoEmpty: '健身视频不能为空'})
      return false
    }
    if (!formValue.cover_url) {
      setErrorMsg({coverEmpty: '视频封面不能为空'})
      return false
    }
    if (!formValue.duration) {
      setErrorMsg({durationEmpty: '视频时长不能为空'})
      return false
    }

    axios.post('/admin/content/fitness_video/edit', { 
      video_oid: formValue.oid,
      title: formValue.title,
      series_oid: formValue.series_oid,
      cover_url: formValue.cover_url,
      video_url: formValue.video_url,
      duration: Number(formValue.duration),
      sort: Number(formValue.sort)
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getFitnessVideoData()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑健身视频'
      destroyOnClose={true}
      width='800px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <Spin spinning={isLoading}>
        <MyInput
          id="title"
          required
          autoFocus
          maxLength={64}
          label='视频标题'
          placeholder='请输入健身视频标题'
          value={formValue.title}
          onChange={setFormValue}
          errorMsg={errorMsg.titleEmpty}
        />

        <MySeriesSelect
          id='series_oid'
          required
          label='选择系列'
          value={formValue.series_oid}
          onChange={setFormValue}
          errorMsg={errorMsg.seriesEmpty}
        />

        <MyVideoUpload 
          id="video_url"
          required
          label='上传视频'
          value={formValue.video_url}
          setValue={setFormValue}
          setIsLoading={setIsLoading}
        />

        <MyImageUpload
          id="cover_url"
          required
          label='视频封面'
          value={formValue.cover_url}
          setValue={setFormValue}
          errorMsg={errorMsg.coverEmpty}
        />

        <MyInput
          required
          type='number'
          id="duration"
          label='视频时长（分）'
          value={formValue.duration}
          onChange={setFormValue}
          styles={{ width: '100px' }}
          min={0}
          max={1000}
        />

        <MyInput
          type='number'
          id="sort"
          label='排序'
          value={formValue.sort}
          onChange={setFormValue}
          styles={{ width: '60px' }}
          min={0}
          max={1000}
        />
      </Spin>
    </Modal>
  )
}

export default EditFitnessVideo
